import { post, get, postUrl, deleteApi, put, imagePost } from "./axios3";

const RESOURCE_BASE_PATH = "/public";
//

/***
 * 推广链接，会员中心URL修改
 * @param p
 */
export const updateMemberCenterURL = (p) =>
  put(`${RESOURCE_BASE_PATH}/updateMemberCenterURL`, p);

// 关闭会员中心URL
export const closeMemberCenterURL = (p) =>
  deleteApi(`${RESOURCE_BASE_PATH}/closeMemberCenterURL`, p);

//   查询会员中心URL状态
export const getMemberCenterURLStatus = (p) =>
  get(`${RESOURCE_BASE_PATH}/getMemberCenterURLStatus`, p);
